
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class mSideSection extends Vue {
  @Prop({ type: Boolean, default: false }) showSideSection: boolean;
  @Prop({ type: Function, default: () => () => {} }) onBackDropClick: Function;
}
